var el = $('.js-container');

// 设置顶部进度条
var total = 0;

for (var key in response.map) {
    total += response.map[key];
}

if (total >= 80000 && total < 180000) {
    el.find('.js-process-mark:eq(0)').removeClass('process__mark--disabled');
    el.find('.js-process-label:eq(0)').removeClass('process-item__label--disabled').text('已解锁');
    el.find('.js-process').animate({ width: (total - 80000) * (59.3 - 32) / (180000 - 80000) + 32 + '%' });
} else if (total >= 180000 && total < 280000) {
    el.find('.js-process-mark:lt(2)').removeClass('process__mark--disabled');
    el.find('.js-process-label:lt(2)').removeClass('process-item__label--disabled').text('已解锁');
    el.find('.js-process').animate({ width: (total - 180000) * (92.7 - 65.4) / (280000 - 180000) + 65.4 + '%' });
} else if (total >= 280000) {
    el.find('.js-process-label').removeClass('process-item__label--disabled').text('已解锁');
    el.find('.js-process-mark').removeClass('process__mark--disabled');
    el.find('.js-process').animate({ width: '100%' });
} else {
    el.find('.js-process').animate({ width: total * 26 / 80000 + '%' });
}

// 设置门派进度条
var maxWidth = 700;

el.find('.js-vs-bar').each(function (i, bar) {
    var $bar = $(bar);
    var count = response.map[$bar.data('id')];

    if (total < 280000) {
        if (count) {
            if (count >= 70000) {
                $bar.show().animate({ width: maxWidth });
            } else {
                $bar.show().animate({ width: count * maxWidth / 70000 });
            }
            $bar.next().text(count);
        }
    } else {
        $bar.show().animate({ width: maxWidth });
        $bar.next().text('已达成');
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./pages/yeyinglunhui/js/vs.js
 ** module id = 0
 ** module chunks = 1
 **/